// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React from "react";
import Link from "redux-first-router-link";

import { Launch as StyledLaunch } from "./styles";
import Icon from "src/components/Icon";
import * as atypes from "src/constants/actionTypes";
import { iconSize } from "src/styles/constants/size";
import defaultFilter from "src/constants/defaultFilter";
import { showView } from "src/actions";
import { updateFilter } from "src/actions/filter";
import { useDispatch } from "react-redux";
import type { ChatroomAddress, WorkflowId } from "src/types";
import {
  getWorkflowName,
  getCurrentLocation,
  getCurrentFilter,
} from "src/reducers";
import { useSelector } from "react-redux";
import { normalizeLocation } from "src/utils";

type Props = {
  address: ChatroomAddress,
  closeConversationModal: Function,
  _showView: Function,
  templateId: ?WorkflowId,
  title: string,
  workflowName: ?string,
};

const Launch = ({
  address,
  closeConversationModal,
  templateId,
  _showView,
  title,
}: Props) => {
  const dispatch = useDispatch();

  const workflowName = useSelector(({ app }) =>
    getWorkflowName(app, templateId || ""),
  );

  const currentFilter = useSelector(({ app }) => getCurrentFilter(app));

  const currentLocation =
    useSelector(({ location }) => getCurrentLocation(location)) || "";

  // Locations to apply filter when navigating from conv. modal.
  const locations = ["reports", "manage"];

  const handleClick = () => {
    const baseLocation = normalizeLocation(currentLocation);
    _showView(defaultFilter.conversations.name);

    if (locations.includes(baseLocation) && templateId && workflowName) {
      dispatch(
        updateFilter({
          ...currentFilter,
          mine: false,
          unread: false,
          text: title,
          workflow: templateId,
          name: workflowName,
        }),
      );
    }
    closeConversationModal();
  };
  return (
    <StyledLaunch>
      <Link
        to={{
          type: atypes.SET_CURRENT_CHATROOM_REQUEST,
          payload: { id: address },
          meta: {
            query: {
              templateId,
            },
          },
        }}
        onClick={handleClick}
      >
        {i18n.t(k.VIEW_IN_ACTIVE_CHAT)}
        <Icon icon="launch" size={iconSize.space_m} />
      </Link>
    </StyledLaunch>
  );
};

export default connect(null, { _showView: showView })(Launch);
